import React, { useState } from 'react';
import { Navbar as BootstrapNavbar, Nav, Container, Button, Offcanvas, Dropdown } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { List, X, House, Book, JournalText, InfoCircle } from 'react-bootstrap-icons';
import logo from '../assets/logo.png';
import '../App.css';

const Navbar = () => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const location = useLocation();

  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const NavLink = ({ to, children, icon: Icon, className = "" }) => (
    <Link 
      to={to} 
      className={`nav-link-custom ${isActive(to) ? 'active' : ''} ${className}`}
      onClick={handleClose}
    >
      {Icon && <Icon className="me-2" />}
      {children}
    </Link>
  );

  return (
    <>
      <BootstrapNavbar expand="lg" className="custom-navbar" fixed="top">
        <Container>
          {/* Logo */}
          <BootstrapNavbar.Brand as={Link} to="/" className="navbar-brand-custom">
            <img 
              src={logo} 
              alt="CBSE Resources" 
              className="navbar-logo"
            />
            <span className="navbar-brand-text">CBSE Resources</span>
          </BootstrapNavbar.Brand>

          {/* Desktop Navigation */}
          <BootstrapNavbar.Collapse className="justify-content-end">
            <Nav className="navbar-nav-custom">
              <NavLink to="/" icon={House}>
                Home
              </NavLink>
              
              <Dropdown className="nav-dropdown">
                <Dropdown.Toggle as={Button} variant="link" className="nav-dropdown-toggle">
                  <Book className="me-2" />
                  Classes
                </Dropdown.Toggle>
                <Dropdown.Menu className="nav-dropdown-menu">
                  <Dropdown.Item as={Link} to="/class/9" className="nav-dropdown-item">
                    Class 9 Resources
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/class/10" className="nav-dropdown-item">
                    Class 10 Resources
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/class/11" className="nav-dropdown-item">
                    Class 11 Resources
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/class/12" className="nav-dropdown-item">
                    Class 12 Resources
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <Dropdown className="nav-dropdown">
                <Dropdown.Toggle as={Button} variant="link" className="nav-dropdown-toggle">
                  <JournalText className="me-2" />
                  Guides
                </Dropdown.Toggle>
                <Dropdown.Menu className="nav-dropdown-menu">
                  <Dropdown.Item as={Link} to="/guide/9" className="nav-dropdown-item">
                    Class 9 Study Guide
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/guide/10" className="nav-dropdown-item">
                    Class 10 Exam Guide
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/guide/11" className="nav-dropdown-item">
                    Class 11 Study Guide
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/guide/12" className="nav-dropdown-item">
                    Class 12 Board Guide
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>

              <NavLink to="/about" icon={InfoCircle}>
                About Us
              </NavLink>

              <NavLink to="/blog" icon={JournalText}>
                Blog
              </NavLink>
            </Nav>
          </BootstrapNavbar.Collapse>

          {/* Mobile Menu Button */}
          <Button 
            variant="outline" 
            className="mobile-menu-btn d-lg-none"
            onClick={handleShow}
            aria-label="Open navigation menu"
          >
            <List size={24} />
          </Button>
        </Container>
      </BootstrapNavbar>

      {/* Mobile Offcanvas Menu */}
      <Offcanvas 
        show={showOffcanvas} 
        onHide={handleClose} 
        placement="end"
        className="mobile-nav-offcanvas"
      >
        <Offcanvas.Header className="mobile-nav-header">
          <div className="mobile-nav-brand">
            <img 
              src={logo} 
              alt="CBSE Resources" 
              className="mobile-nav-logo"
            />
            <span className="mobile-nav-brand-text">CBSE Resources</span>
          </div>
          <Button 
            variant="outline" 
            onClick={handleClose}
            className="mobile-nav-close"
            aria-label="Close navigation menu"
          >
            <X size={20} />
          </Button>
        </Offcanvas.Header>
        
        <Offcanvas.Body className="mobile-nav-body">
          <Nav className="flex-column mobile-nav-links">
            <NavLink to="/" icon={House}>
              Home
            </NavLink>
            
            <NavLink to="/class/9" icon={Book}>
              Class 9 Resources
            </NavLink>
            
            <NavLink to="/class/10" icon={Book}>
              Class 10 Resources
            </NavLink>
            
            <NavLink to="/class/11" icon={Book}>
              Class 11 Resources
            </NavLink>
            
            <NavLink to="/class/12" icon={Book}>
              Class 12 Resources
            </NavLink>

            <div className="mobile-nav-divider"></div>

            <NavLink to="/guide/9" icon={JournalText}>
              Class 9 Study Guide
            </NavLink>
            
            <NavLink to="/guide/10" icon={JournalText}>
              Class 10 Exam Guide
            </NavLink>
            
            <NavLink to="/guide/11" icon={JournalText}>
              Class 11 Study Guide
            </NavLink>
            
            <NavLink to="/guide/12" icon={JournalText}>
              Class 12 Board Guide
            </NavLink>

            <div className="mobile-nav-divider"></div>

            <NavLink to="/about" icon={InfoCircle}>
              About Us
            </NavLink>

            <NavLink to="/blog" icon={JournalText}>
              Blog
            </NavLink>
          </Nav>
          
          <div className="mobile-nav-footer">
            <p className="mobile-nav-footer-text">
              Curated CBSE study materials from top educators across India
            </p>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Navbar;
